import styled from 'styled-components';
import { ConsolePanel, MetaRow } from '@/ui';
import type { Community } from '@/core/models/community';

const Panel = styled(ConsolePanel)`margin-top: 14px; display: flex; flex-direction: column; gap: 10px;`;
const H = styled.h3`margin: 0; font-family: ${({ theme }) => theme.font.display}; font-size: ${({ theme }) => theme.fontSize.md}; color: ${({ theme }) => theme.color.textPrimary};`;
const P = styled.p`margin: 0; font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textMuted};`;
const Meta = styled.p`margin: 0; font-family: ${({ theme }) => theme.font.mono}; font-size: ${({ theme }) => theme.fontSize.xs}; color: ${({ theme }) => theme.color.textMuted};`;

export function AboutTab({ community }: { community: Community }) {
  return (
    <Panel>
      <H>About {community.name}</H>
      <P>{community.description}</P>
      <Meta>
        <MetaRow>
          <span>{community.category}</span>
          <span>{community.members}</span>
          <span>{community.postsCount} posts</span>
        </MetaRow>
      </Meta>
    </Panel>
  );
}
